import React from "react";

import styled from "styled-components";

import Demo from "./Icons/Demo";
import Image from 'react-bootstrap/Image'
import Linkify from 'react-linkify';

const Section = styled.section`
  padding: 30px 0 225px;
`;
const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: 800;
  line-height: normal;
  color: #f0df73;
  text-align: center;
  margin-bottom: 2px;
`;

const SubTitle = styled.h5`
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  color: #aeaeae;
  margin-bottom: 25px;
  @media (min-width: 992px) {
    margin-bottom: 50px;
  }
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 30px;
  &:hover {
    transform: translateY(-5px) !important;
  }

  @media (min-width: 992px) {
    margin-bottom: 0;
  }
`;

const IconWrap = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 150px;
  border: solid 1px #eff2f9;
  background-color: #f8faff;
  margin-bottom: 30px;
  position: relative;
  > svg {
    transition: all 0.3s ease-in;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &:hover {
    > svg {
      transform: translate(-50%, -50%) rotateY(360deg);
    }
  }
`;

const BoxTitle = styled.h4`
  font-size: 18px;
  font-weight: 300;
  line-height: normal;
  color: #5273c7;
`;

const BoxTitle2 = styled.h4`
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
  margin-top: 20px;
  color: #e8b210;
`;

const Text = styled.p`
  font-size: 18px;
  font-weight: bold;
  line-height: 1.58;
  color: #fff;
  margin-left: 50px;
  max-width: 1500px;
  text-align: left;
`;

const GradStudents = () => {
  const width = window.innerWidth;
  return (
    <Section id="gradstudents">
      <div className="col-lg-12">
        <SectionTitle>TEAM</SectionTitle>
        <div className="row" style={{marginTop:40}}>
          <div className="col-lg-3" style={{marginLeft:10}}>
            <Box data-aos={width >= 1400 ? "fade-right" : "fade-up"}>
            <Image src={require ("../assets/img/yaw.jpg")} width='80%' height='345px' roundedCircle />
            <BoxTitle2>Dr. Yaw Adu-Gyamfi</BoxTitle2>
            </Box>
          </div>
          <Linkify>
          <div className="col-lg-8">
            <Text >
            Yaw Adu-Gyamfi, Ph.D., is an Assistant Professor in the Civil Engineering at the University of Missouri-Columbia (UMC). 
            He  has  a  successful  track record  in  developing  cutting-edge  database  solutions,  and  data  products  geared towards  
            improving  transportation  systems  management  and  operations.His  focus  areas include traffic  operations, intelligent 
            transportation systems, civil infrastructure systems,big data analytics and artificial intelligence.Prior to UMC, he was an 
            associate scientist with Iowa State University, where he served as architect and applications developer on numerous projects 
            which involved using data mining and predictive analytics to solve large-scale, complex and challenging transportation problems.   
            He   co-lead   the   development   of   REACTOR (REaltime   AnalytiCs   of TranspORtation data): A big data laboratory, nationally 
            recognizedfor its ability to ingest multiple streams of real-time  data  and  assist  in  driving  transportation  policy  decisions. 
             The  labs  efforts  are  focused  on  ingestion,  real-time analytics, batch processing, visualization/front end development, and 
             archiving of numerous data streamsfrom Iowa DOT, various TMCs and planning agencies in Iowa.He also worked as a research scientist 
             for the smart lab laboratory at  the  University  of  Virginia  where  he  focused  on  developing  cloud  based  analytic  solutions  
             for  real  time  traffic operations  performance  monitoring. The  majority  of  hisrecent  projects  are  tied  to  big  data  
             warehousing  and transportation data analytics. He has received Civil Engineering degrees from University of Delaware (Ph.D., M.S.) 
             and Geomatic Engineering degree from University of Science and Technology (B.S.).
            </Text>
          </div>
          </Linkify>
          
        </div>
        <div className="row" style={{marginTop:40}}>
          <div className="col-lg-3">
            {/* <Box data-aos={width >= 1400 ? "fade-right" : "fade-up"}> */}
            <Image src={require ("../assets/img/vishal.JPG")} width='100%' height='230px' roundedCircle />
              <BoxTitle2>Vishal Mandal - Masters</BoxTitle2>
              <Text style={{marginBottom:20, width:'100%'}}>
              Computer Vision, Traffic Flow Dynamics, Systems Engineering 
              </Text>
            {/* </Box> */}
          </div>
          <div className="col-lg-3">
            <Box data-aos="fade-up">
            <Image src={require ("../assets/img/neetu.JPG")} width='100%' height='230px' roundedCircle />
              <BoxTitle2>Neetu Choubey - Masters </BoxTitle2>
              <Text>
                Transportation Planning, Geographic Information Systems.
              </Text>
            </Box>
          </div>
          <div className="col-lg-3">
            <Box data-aos={width >= 1400 ? "fade-left" : "fade-up"}>
            <Image src={require ("../assets/img/majed.JPG")} width='100%' height='230px' roundedCircle />
              <BoxTitle2>Shoman Maged - PhD Candidate </BoxTitle2>
              <Text>
                Big Data Analytics, Transportation Planning, Data Visualization
              </Text>
            </Box>
          </div>
          <div className="col-lg-3">
            <Box data-aos={width >= 1400 ? "fade-left" : "fade-up"}>
            <Image src={require ("../assets/img/lan.JPG")} width='100%' height='230px' roundedCircle />
              <BoxTitle2>Lan Uong - PhD Candidate</BoxTitle2>
              <Text>
                Predictive Analytics, Traffic Operations, Machine Learning. 
              </Text>
            </Box>
          </div>
          <div className="col-lg-3">
            <Box data-aos={width >= 1400 ? "fade-left" : "fade-up"}>
            <Image src={require ("../assets/img/abdul.JPG")} width='100%' height='230px' roundedCircle />
              <BoxTitle2>Abdul Musah - PhD Candidate</BoxTitle2>
              <Text>
                Transportation Safety and Planning, Intelligent Transportation Systems, Machine Learning. 
              </Text>
            </Box>
          </div>
          <div className="col-lg-3">
            <Box data-aos={width >= 1400 ? "fade-left" : "fade-up"}>
            <Image src={require ("../assets/img/jinpeng")} width='100%' height='230px' roundedCircle />
              <BoxTitle2>Jin Peng - Masters </BoxTitle2>
              <Text>
              Artificial Intelligence, Big Data Analytics, Traffic Safety and Operations. 
              </Text>
            </Box>
          </div>
          <div className="col-lg-3">
            <Box data-aos={width >= 1400 ? "fade-left" : "fade-up"}>
              <Image src={require ("../assets/img/xiaofan.JPG")} width='100%' height='230px' roundedCircle />
              <BoxTitle2>Xiaofan Shu - Masters </BoxTitle2>
              <Text>
              Data Visualization, Big Data Analytics, Intelligent Transportation Systems. 
              </Text>
            </Box>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default GradStudents;
